
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pozabljeno-geslo",
      function () {
        return require("private-next-pages/pozabljeno-geslo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pozabljeno-geslo"])
      });
    }
  